import React, { useState, useEffect } from 'react'
import { Button, Col, Space, Form } from 'antd'
import {
  successNotification,
  carOrdersUrl,
  putRequest,
  shippingCompaniesUrl,
  getRequest,
} from '../../config'
import NumberInput from '../../components/Forms/NumberInput'
import SelectInput from '../../components/Forms/SelectInput'
import SelectSearch from '../../components/Forms/SelectInputInteractive'
import BasicInput from '../../components/Forms/BasicInput'
import WithData from 'hocs/WithData'
import { withRouter } from 'react-router-dom'
import {
  ARRIVED,
  DELIVERED,
  ORDER_STATUSES,
  ORDER_DELIVERY_STATUSES,
  PENDING,
  SHIPPED,
  ORDERED,
  IN_WAREHOUSE,
  IN_TRANSIT,
  LOCAL_CUSTOMS
} from 'app-constants'
import PropTypes from 'prop-types'

const OrderUpdate = props => {
  const [payload, setPayload] = useState({
    car: props.order.car.id,
    user: props.order.user.id,
    quantity: props.order.quantity,
    paymentStatus: props.order.paymentStatus,
    deliveryStatus: props.order.deliveryStatus,
    useCustomAmount: false,
    pricePerUnit: props.order.pricePerUnit,
    note: props.order.note,
    notifyUser: false,
    shippingCompany: props.order.shippingCompany
      ? props.order.shippingCompany.id
      : '',
    eta: props.order.eta ? props.order.eta : '',
    containerNumber: props.order.containerNumber
      ? props.order.containerNumber
      : '',
    billOfLading: props.order.billOfLading ? props.order.billOfLading : '',
    orderedOn: props.order.orderedOn ? props.order.orderedOn : '',
  })

  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [shippingCompanies, setShippingCompanies] = useState([])

  const handleSelect = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleNumberInput = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleInputChange = stateName => event => {
    setPayload({ ...payload, [stateName]: event.target.value })
  }

  const handleUpdate = async event => {
    event.preventDefault()
    const response = await putRequest(
      carOrdersUrl + '/' + props.order.id,
      { ...payload, orderedOn: payload.orderedOn ? payload.orderedOn : null },
      'car orders',
      setLoading
    )

    if (response.success) {
      props.handleCancel(response.data)
      successNotification('Order Updated')
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  const getShippingCompanies = async () => {
    const response = await getRequest(
      shippingCompaniesUrl,
      'shipping companies',
      setLoading
    )
    if (response.success) {
      setShippingCompanies(
        response.data.results.map(ship => {
          return {
            ...ship,
            label: `${ship.name} - ${ship.origin.country}`,
            value: ship.id
          }
        })
      )
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  useEffect(() => {
    getShippingCompanies()

    // eslint-disable-next-line
  }, [])

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Form className="p-2rem" layout="vertical">
            <div
              className="row"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              <div className="col-md-5">
                <SelectSearch
                  placeholder="search by car chassis number"
                  label="Choose car"
                  name="car"
                  value={payload.car}
                  onChange={handleSelect('car')}
                  optionList={[
                    {
                      value: props.order.car.id,
                      label: `${props.order.car.year} ${props.order.car.make.name} ${props.order.car.model.name} ${props.order.car.trim} - ${props.order.car.chassisNo}`
                    }
                  ]}
                  disabled={true}
                  required={true}
                />
                {serverErrors.car &&
                  serverErrors.car.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <SelectSearch
                  placeholder="search by phone number"
                  label="Choose customer"
                  name="customer"
                  value={payload.user}
                  onChange={handleSelect('user')}
                  optionList={[
                    {
                      value: props.order.user.id,
                      label: `${props.order.user.firstName ? props.order.user.firstName : 'No name'} - ${props.order.user.phoneNumber}`
                    }
                  ]}
                  disabled={true}
                  required={true}
                />
                {serverErrors.user &&
                  serverErrors.user.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <SelectInput
                  placeholder={'select shipping company'}
                  label={'Choose shipping company'}
                  name={'shipping company'}
                  value={payload.shippingCompany}
                  onChange={handleSelect('shippingCompany')}
                  optionList={shippingCompanies}
                  required={true}
                  loading={loading}
                />
                {serverErrors.shippingCompany &&
                  serverErrors.shippingCompany.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <NumberInput
                  label="Quantity"
                  value={payload.quantity}
                  name={'quantity'}
                  placeholder="quantity"
                  handleChange={handleNumberInput('quantity')}
                  required={true}
                  min={1}
                  max={1000}
                  disabled={payload.paymentStatus === PENDING ? false : true}
                />
                {serverErrors.quantity &&
                  serverErrors.quantity.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <SelectInput
                  placeholder={'select payment status'}
                  label={'Choose payment status'}
                  name={'payment status'}
                  value={payload.paymentStatus}
                  onChange={handleSelect('paymentStatus')}
                  optionList={ORDER_STATUSES}
                  required={true}
                  loading={loading}
                />
                {serverErrors.paymentStatus &&
                  serverErrors.paymentStatus.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <SelectInput
                  placeholder={'select delivery status'}
                  label={'Choose delivery status'}
                  name={'deliveryStatus'}
                  value={payload.deliveryStatus}
                  onChange={handleSelect('deliveryStatus')}
                  optionList={ORDER_DELIVERY_STATUSES}
                  required={true}
                  loading={loading}
                />
                {serverErrors.deliveryStatus &&
                  serverErrors.deliveryStatus.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              {[
                ORDERED,
                IN_WAREHOUSE,
                SHIPPED,
                IN_TRANSIT,
                LOCAL_CUSTOMS,
                ARRIVED,
                DELIVERED
              ].includes(payload.deliveryStatus) ? (
                <div className="col-md-5">
                  <SelectInput
                    placeholder="select"
                    label="Notify user about this order?"
                    name="notifyUser"
                    value={payload.notifyUser}
                    onChange={handleSelect('notifyUser')}
                    optionList={[
                      {
                        label: 'Yes',
                        value: true
                      },
                      {
                        label: 'No',
                        value: false
                      }
                    ]}
                    required={true}
                  />
                  {serverErrors.notifyUser &&
                    serverErrors.notifyUser.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              ) : null}

              <div className="col-md-5">
                <SelectInput
                  placeholder={'select option'}
                  label={'Do you want to use a custom amount for this order?'}
                  name={'useCustomAmount'}
                  value={payload.useCustomAmount}
                  onChange={handleSelect('useCustomAmount')}
                  optionList={[
                    {
                      label: 'Yes',
                      value: true
                    },
                    { label: 'No use product amount', value: false }
                  ]}
                  required={true}
                  loading={loading}
                />
                {serverErrors.useCustomAmount &&
                  serverErrors.useCustomAmount.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              {payload.useCustomAmount ? (
                <div className="col-md-5">
                  <BasicInput
                    label={'Enter order amount'}
                    value={payload.pricePerUnit}
                    name={'pricePerUnit'}
                    placeholder="pricePerUnit"
                    handleChange={handleInputChange('pricePerUnit')}
                    required={true}
                  />
                  {serverErrors.pricePerUnit &&
                    serverErrors.pricePerUnit.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              ) : null}

              {payload.useCustomAmount ? (
                <div className="col-md-5">
                  <BasicInput
                    label={'A note for this order'}
                    value={payload.note}
                    name={'note'}
                    placeholder="note"
                    handleChange={handleInputChange('note')}
                    required={true}
                  />
                  {serverErrors.note &&
                    serverErrors.note.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              ) : null}

              <div className="col-md-5">
                <BasicInput
                  label={'Order Placed On (YYYY-MM-DD)'}
                  value={payload.orderedOn}
                  name={'orderedOn'}
                  placeholder="ordered on"
                  handleChange={handleInputChange('orderedOn')}
                  required={false}
                />
                {serverErrors.orderedOn &&
                  serverErrors.orderedOn.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label={'ETA (YYYY-MM-DD)'}
                  value={payload.eta}
                  name={'eta'}
                  placeholder="eta"
                  handleChange={handleInputChange('eta')}
                  required={false}
                />
                {serverErrors.eta &&
                  serverErrors.eta.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label={'Container Number'}
                  value={payload.containerNumber}
                  name={'containerNumber'}
                  placeholder="container number"
                  handleChange={handleInputChange('containerNumber')}
                  required={false}
                />
                {serverErrors.containerNumber &&
                  serverErrors.containerNumber.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label={'Bill of Lading Number'}
                  value={payload.billOfLading}
                  name={'billOfLading'}
                  placeholder="bill of lading number"
                  handleChange={handleInputChange('billOfLading')}
                  required={false}
                />
                {serverErrors.billOfLading &&
                  serverErrors.billOfLading.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-10 text-muted small mb-3">
                For a car shipped in a container, enter its container number. For a RoRo car,
                enter the bill of lading number. Tracking uses these to offer the customer our
                clearing service.
              </div>

              {serverErrors.nonFieldErrors &&
                serverErrors.nonFieldErrors.map((err, i) => (
                  <div className="text-danger" key={i}>
                    {err}
                  </div>
                ))}

              <Col md={24}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: '20px'
                  }}
                >
                  <Space>
                    {/* eslint-disable-next-line react/prop-types */}
                    <Button onClick={() => props.handleCancel()}>
                      Cancel{' '}
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleUpdate}
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Space>
                </div>
              </Col>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

OrderUpdate.propTypes = {
  handleCancel: PropTypes.func,
  order: PropTypes.object
}

export default WithData(withRouter(OrderUpdate))
